import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './smalldashboard.scss'

// Actions
import { GetSmallDashboard } from '../../actions/shops'

// import components
import Header from '../../shared/components/Header'

// Utils
import { renderFullDate } from '../../utils/time'
import { formatCurrency } from '../../utils/currency'
import { hasSubscriptionPermission } from '../../utils/auth'
import { translation } from '../../utils/helpers'

// Elements
import Col from '../../shared/elements/col'
import Panel from '../../shared/elements/panel'
import Button from '../../shared/elements/button'
import LabelWrapper from '../../shared/elements/labelWrapper'
// import PanelHeader from '../../shared/elements/panelHeader'
import Divider from '../../shared/elements/divider'
import Inline from '../../shared/elements/inline'
import Icon from '../../shared/elements/icon'

import { DashboardIcons } from '../../shared/elements/icons'

class SmallDashboard extends Component {
  constructor (props) {
    super(props)
    this.state = {
      smallDashboard: {
        PeriodStart: undefined,
        PeriodStop: undefined,
        Turnover: 0,
        OrderCount: 0,
        ForsiOrderCount: 0,
        EvaluationCount: 0,
        AfterEvaluationCount: 0,
        DocumentationCount: 0,
        PhotoOrderCount: 0,
        PhotoRegistrationCount: 0,
        FullDashboardUrl: '',
        FullReportUrl: ''
      }
    }
    this.getSmallDashboard = this.getSmallDashboard.bind(this)
  }

  componentDidMount () {
    this.getSmallDashboard()
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.params.orderID !== this.props.params.orderID) {
      this.setState({
        smallDashboard: {
          PeriodStart: undefined,
          PeriodStop: undefined,
          Turnover: 0,
          OrderCount: 0,
          ForsiOrderCount: 0,
          EvaluationCount: 0,
          AfterEvaluationCount: 0,
          DocumentationCount: 0,
          PhotoOrderCount: 0,
          PhotoRegistrationCount: 0,
          FullDashboardUrl: '',
          FullReportUrl: ''
        }
      })
      this.getSmallDashboard(nextProps)
    }
  }

  getSmallDashboard (props) {
    props = (typeof props === 'undefined') ? this.props : props
    this.props.GetSmallDashboard(props.params.orderID).then((res) => {
      this.setState({
        smallDashboard: res.data
      })
    }, () => {
      window.toastr.error(translation('1790'), translation('216'))
      this.props.router.goBack()
    })
  }

  renderAssessment () {
    return (
      <LabelWrapper labelText={translation('901')} key='assessment'>
        <Inline spacing='0' block fillChildNum={[0]}>
          {translation('13363')}
          <span className='value'>{this.state.smallDashboard.EvaluationCount}</span>
        </Inline>
        <Inline spacing='0' block fillChildNum={[0]}>
          {translation('1037')}
          <span className='value'>{this.state.smallDashboard.AfterEvaluationCount}</span>
        </Inline>
      </LabelWrapper>
    )
  }

  renderPhotoDocumentation () {
    return (
      <LabelWrapper labelText={translation('2065')} key='photodoc'>
        <Inline spacing='0' block fillChildNum={[0]}>
          {translation('14812')}
          <span className='value'>{this.state.smallDashboard.DocumentationCount}</span>
        </Inline>
        <Inline spacing='0' block fillChildNum={[0]}>
          {translation('14813')}
          <span className='value'>{this.state.smallDashboard.PhotoRegistrationCount}</span>
        </Inline>
        <Inline spacing='0' block fillChildNum={[0]}>
          {translation('1096')}
          <span className='value'>{this.state.smallDashboard.PhotoOrderCount}</span>
        </Inline>
      </LabelWrapper>
    )
  }

  renderReportButtons () {
    // let isBodyShop = this.props.auth.departmentType === 1
    let showDashboardReport = this.props.auth.user.ChainId !== '2' && this.props.auth.user.ChainId !== '8'  // Disable for QARS for now (while paint and body reports are not being maintained)
    let showQarsReport = this.props.auth.user.ChainId === '2' || this.props.auth.user.ChainId === '8'

    // Renders report link button for chain or shop report.
    const renderDWLink = (reportType = 0) => {
      let url = '/DataWarehouse/' + reportType
      let to = translation(187)
      let reports = translation(436)
      let title = `${to} ${reports}`

      return (
        <a href={url} >
          <Button style='link' labelText={(
            <Inline spacing={0}>
              {title}
              <Icon className='topright' icon={DashboardIcons.Arrow_Black} />
            </Inline>
          )} />
        </a>
      )
    }

    return (
      <div>
        {showDashboardReport && renderDWLink(0)}
        {showQarsReport && renderDWLink(1)}
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30, 10)) return null

    let isBodyShop = this.props.auth.departmentType === 1

    return (
      <div className='smalldashboard__page'>
        <Header router={this.props.router} />
        <div className='smalldashboard__page--inner'>
          <Col span={1}>
            <Panel title={translation('1102')}>
              <span className='title'>{translation('1103') + ' ' + renderFullDate(this.state.smallDashboard.PeriodStart, false) + ' - ' + renderFullDate(this.state.smallDashboard.PeriodStop, false)}</span>
              <Divider noLine />
              <LabelWrapper labelText={translation('1090')}>
                <Inline spacing='0' block fillChildNum={[0]}>
                  {translation('1095')}
                  <span className='amount'>{formatCurrency(this.state.smallDashboard.Turnover, 0)}</span>
                </Inline>
                <Inline spacing='0' block fillChildNum={[0]}>
                  {translation('1096')}
                  <span className='value'>{this.state.smallDashboard.OrderCount}</span>
                </Inline>
                <Inline spacing='0' block fillChildNum={[0]}>
                  {translation('1097')}
                  <span className='value'>{this.state.smallDashboard.ForsiOrderCount}</span>
                </Inline>
              </LabelWrapper>

              {!isBodyShop && [
                <Divider noLine key='1' />,
                this.renderAssessment(),
                <Divider noLine key='3' />,
                this.renderPhotoDocumentation()
              ]}

              <Divider noLine />
              {this.renderReportButtons()}
            </Panel>
          </Col>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetSmallDashboard
})(SmallDashboard)



// WEBPACK FOOTER //
// ./src/app/pages/SmallDashboard/index.js